import { defineMessages } from 'utils/intl';

export default defineMessages({
  loggedOut: 'Zaloguj się / utwórz konto',
  loggedIn: 'Twoje konto',
});
